import { render, staticRenderFns } from "./cart-delivery-address.vue?vue&type=template&id=27a3fca8"
import script from "./cart-delivery-address.vue?vue&type=script&lang=js"
export * from "./cart-delivery-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cart-delivery-address.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports